export const laptop = {
  name: "laptop" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M2.6 5a.9.9 0 0 1 .9-.9h17a.9.9 0 0 1 .9.9v10.787l1.405 2.81A.9.9 0 0 1 22 19.9H2a.9.9 0 0 1-.805-1.302l1.405-2.81V5Zm1.456 11.9-.6 1.2h17.088l-.6-1.2H4.056ZM19.6 15.1V5.9H4.4v9.2h15.2Z" clip-rule="evenodd"/></svg>`,
  keywords: ["laptop"],
  category: "device" as const,
};
